module.exports = __webpack_public_path__ + "static/img/bank_logo.533bbf8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/common/bank_logo.png
// module id = zPeT
// module chunks = 1